import React from 'react';
import './Testimonials.css';

function Testimonials() {
  const testimonials = [
    {
      id: 1,
      name: 'JAMES PASECKI',
      text: 'Excelente serviço de impressão 3D! A qualidade das peças superou minhas expectativas. Profissionais atenciosos e comprometidos com prazos.',
      avatar: '👤'
    },
    {
      id: 2,
      name: 'JOHN MC CONNICK',
      text: 'Trabalho impecável! Conseguiram transformar minha ideia em realidade com precisão e acabamento perfeito. Recomendo muito!',
      avatar: '👤'
    },
    {
      id: 3,
      name: 'ALEXA SZCZUKOWSKI',
      text: 'Equipe muito profissional e prestativa. O projeto ficou exatamente como eu imaginava. Certamente voltarei a fazer negócios!',
      avatar: '👤'
    }
  ];

  return (
    <section className="testimonials-section" id="depoimentos">
      <h2>DEPOIMENTOS</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card">
            <div className="testimonial-avatar">{testimonial.avatar}</div>
            <p className="testimonial-name">{testimonial.name}</p>
            <p className="testimonial-text">"{testimonial.text}"</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
